// extracted by mini-css-extract-plugin
module.exports = {"StepLarge":"StepLarge_StepLarge__3Y_qr","Number":"StepLarge_Number__F9gqq","Name":"StepLarge_Name__1noD4"};